import React, { useEffect, useState } from 'react';
import { Typography, Container, FormControl, Button, InputLabel, Select, Divider, IconButton, MenuItem, Grid, Toolbar, Paper, CircularProgress } from '@material-ui/core'
import { useForm, Controller } from "react-hook-form";
import DownloadIcon from '@material-ui/icons/SaveAlt';
import SearchIcon from '@material-ui/icons/Search';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl'
import MaterialTable, { MTableToolbar }  from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, ConfirmPaymentActions} from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px',
    },
    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const confirmPaymentSelector = (state) => state.ConfirmPayment;
const IdentitySelector = (state) => state.Identity;

const PaymentConfirmation = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const confirmPaymentActions = bindActionCreators(ConfirmPaymentActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { listConfirm, nowWainting } = useSelector(confirmPaymentSelector);
    const { token, userData } = useSelector(IdentitySelector);

    // React Hook Form
    const { control } = useForm();

    const { classes, intl } = props;

    // 一覧タイトル用
    const [searchDateTitle, setSearchDateTitle] = useState();
    // 検索実行時の年月（yyyy/mm/01形式、PDF/CSVダウンロード時に検索結果と同一の精算書を特定するために使用）
    const [searchedNengetsu, setSearchedNengetsu] = useState();

    const listDefinition = {
        columns: [
            {
                // 締切日（MaterialTable は columns を deep equal するため JSX 不可）
                title: intl.formatMessage({ id: 'Adjustment.DeadLine' }),
                field: 'end_dt',
            },
            {
                // 確定日
                title: intl.formatMessage({ id: 'Adjustment.FixedDate' }),
                field: 'fix_dt',
            },
            {
                // 精算書
                title: intl.formatMessage({ id: 'Adjustment.AccountStatement' }),
                field: 'payment_document',
                render: rowData => {
                    return (
                        <div>
                            <Button onClick={() => onAccountStatementClick(rowData)} variant="contained" color="secondary" size="small" endIcon={<DownloadIcon />}>
                                <FormattedMessage id="Button.Download" />
                            </Button>
                        </div>
                    )
                }
            },
            {
                // 日別CSVファイル
                title: intl.formatMessage({ id: 'Adjustment.CSVFileDaily' }),
                field: 'detail_csv_file',
                render: rowData => {
                    return (
                        <div>
                            <Button onClick={() => onDetailCSVFileClick(rowData, 1)} variant="contained" color="secondary" size="small" endIcon={<DownloadIcon />}>
                                <FormattedMessage id="Button.Download" />
                            </Button>
                        </div>
                    )
                }
            },
            {
                // 明細CSVファイル
                title: intl.formatMessage({ id: 'Adjustment.CSVFileDetail' }),
                field: 'detail_csv_file_2',
                render: rowData => {
                    return (
                        <div>
                            <Button onClick={() => onDetailCSVFileClick(rowData, 2)} variant="contained" color="secondary" size="small" endIcon={<DownloadIcon />}>
                                <FormattedMessage id="Button.Download" />
                            </Button>
                        </div>
                    )
                }
            },
            {
                // ポイント明細CSVファイル
                title: intl.formatMessage({ id: 'Adjustment.CSVFilePointDetail' }),
                field: 'detail_csv_file_3',
                render: rowData => {
                    return (
                        <div>
                            <Button onClick={() => onDetailCSVFileClick(rowData, 3)} variant="contained" color="secondary" size="small" endIcon={<DownloadIcon />}>
                                <FormattedMessage id="Button.Download" />
                            </Button>
                        </div>
                    )
                }
            },
        ]
    };

    /**
     *
     * 検索ボタン押下時の処理
     *
     */
    const onSearchClick = () => {
        // 検索年月をAPI用に yyyy/mm/dd形式に変換
        var yyyy = searchDate.slice(0, 4);
        var mm = searchDate.slice(-2);
        var searchDt = yyyy + '/' + mm + '/01';
        // 精算書確認情報リストを取得
        confirmPaymentActions.listConfirmPayment(token, props.merchantId, searchDt)
            .then(data => {
                var title = yyyy + '年' + mm + '月';
                setSearchDateTitle(title);
                setSearchedNengetsu(searchDt);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 戻る押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * base64 文字列をデコードしてブラウザダウンロードを実行します。
     */
    const downloadBlob = (b64Data, contentType, fileName, withBom) => {
        const byteCharacters = atob(b64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const parts = withBom ? [new Uint8Array([0xEF, 0xBB, 0xBF]), byteArray] : [byteArray];
        const blob = new Blob(parts, { type: contentType });
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        let link = document.createElement('a');
        link.download = fileName;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    /**
     *
     * 精算書ダウンロード押下時の処理（API から PDF を取得してダウンロード）
     *
     */
    const onAccountStatementClick = (rowData) => {
        var endDt = rowData.end_dt.replace('/', '');
        var fixDt = rowData.fix_dt.replace('/', '');
        const fileName = `精算書_${props.merchantName}_${searchDateTitle}_${endDt}_${fixDt}.pdf`;

        confirmPaymentActions.downloadPdf(token, props.merchantId, rowData.seq, searchedNengetsu)
            .then(fileData => {
                if (!fileData) {
                    throw new Error('PDF データが取得できませんでした。');
                }
                downloadBlob(fileData, 'application/pdf', fileName, false);
                notificationActions.showSuccess(`ダウンロードしました。（${fileName}）`);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * CSVファイルダウンロード押下時の処理（API から CSV を取得してダウンロード）
     *
     */
    const onDetailCSVFileClick = (rowData, type) => {
        var endDt = rowData.end_dt.replace('/', '');
        var fixDt = rowData.fix_dt.replace('/', '');

        var typeName;
        if (type === 1)      typeName = '日別';
        else if (type === 2) typeName = '明細';
        else if (type === 3) typeName = 'ポイント明細';

        const fileName = `精算書明細（${typeName}）_${props.merchantName}_${searchDateTitle}_${endDt}_${fixDt}.csv`;

        confirmPaymentActions.downloadCsv(token, props.merchantId, rowData.seq, type, searchedNengetsu)
            .then(fileData => {
                if (!fileData) {
                    throw new Error('CSV データが取得できませんでした。');
                }
                downloadBlob(fileData, 'text/csv', fileName, true);
                notificationActions.showSuccess(`ダウンロードしました。（${fileName}）`);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;

        if (name.startsWith('nengestu')) {
            setSearchDate(value);
        }

        return value;
    }

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        // 一覧を初期化
        confirmPaymentActions.initListConfirmPayment();
    }, []);

    var merchantTypeName = '';
    switch (props.merchantType) {
        case 'acquirer':
            merchantTypeName = '代表加盟店';
            break;
        case 'general':
            merchantTypeName = '一般加盟店';
            break;
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    // 当月含めて過去13ヵ月分を選択可能
    const NENGETSU_SELECT_MONTHS = 13;
    var nengetsu = [];
    var defaultValue;
    var i;
    for (i = 0; i < NENGETSU_SELECT_MONTHS; i++) {
        // nヶ月前
        var dt = new Date();
        // yyyy/mm/dd 日にちは必ず存在する15日に固定
        dt = new Date(dt.getFullYear(), dt.getMonth() - i, 15);
        let value = dt.getFullYear() + ("0" + (dt.getMonth() + 1)).slice(-2);
        let title = dt.getFullYear() + '年' + ("0" + (dt.getMonth() + 1)).slice(-2) + '月';
        var addData = { value: value, title: title };
        nengetsu.push(addData);
        if (i == 0) {
            defaultValue = value;
        }
    }
    // 当月を初期表示(yyyymm形式保持)
    const [searchDate, setSearchDate] = useState(defaultValue);

    var backButton = <div></div>;
    if (userData.role == 1 || userData.role == 2 || userData.role == 3) {
        // システム管理者および沖縄ICカード、代表加盟店アカウント
        // 加盟店リストに戻るボタンを表示
        backButton =
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h2" variant="inherit"><FormattedMessage id="Adjustment.PaymentConfirmation" /></Typography>
                                <div>
                                    <Button fullWidth id="searchButton" variant="contained" size="medium" color="primary"
                                        startIcon={<SearchIcon />}
                                        onClick={onSearchClick}><FormattedMessage id="Button.Search" /></Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <InputLabel component="legend"><FormattedMessage id={"Adjustment.MerchantName"} /></InputLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <InputLabel component="legend">{props.merchantName}</InputLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel component="legend"><FormattedMessage id={"Adjustment.MerchantType"} /></InputLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <InputLabel component="legend">{merchantTypeName}</InputLabel>
                        </Grid>
              
                        <Grid item xs={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="adjustment-label-date"><FormattedMessage id={"Adjustment.YearAndMonth"} /></InputLabel>
                                <Controller
                                    name="nengestu"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={defaultValue}
                                    as={<Select
                                        labelId="adjustment-label-date"
                                        id="adjustment-date"
                                        name="nengetsu"
                                        label={<FormattedMessage id={"Adjustment.YearAndMonth"} />}>
                                        {nengetsu.map((date) => {
                                            return <MenuItem value={date.value}>{date.title}</MenuItem>
                                        })}
                                    </Select>} />
                            </FormControl>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{searchDateTitle}</Typography>}
                columns={listDefinition.columns}
                data={listConfirm}
                options={{
                    search: false,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <div></div>
                            )
                        } else {
                            return (
                                <div></div>
                            )
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />

            {backButton}

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(injectIntl(PaymentConfirmation));
